<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      <div
        class="card-head box-shadow bg-white d-md-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
      >
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher un approvisionnement"
          />
          <button
            type="submit"
            class="bg-transparent text-primary transition p-0 border-0"
          >
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
        <div class="d-sm-flex align-items-center">

          <router-link to="/Ajout-Approvisionnement" class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            <span class="title">Faire un approvisionnement</span>
          </router-link>
          
          <button
            class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mt-10 mt-md-0"
            type="button"
          >
            Export
            <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  date
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                >
                  Reference
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  montant
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(vente, index) in elements" :key="index">
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.id }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{  format_date(vente.dateAppro) }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{  vente.reference }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-paragraph">
                  {{ vente.montant }}
                </td>
                <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
              <div class="dropdown">
                  <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" 
                        data-bs-toggle="modal"
                        data-bs-target="#MyModal"
                        @click="detail(vente.id)"
                      >
                        <i
                          class="flaticon-eye lh-1 me-8 position-relative top-1" 
                        ></i>
                        Détail
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);" @click="suppression(vente.id,elements,'approvisionnement','cette approvisionnement ?')"
                      >
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Annuler cet approvisionnement
                      </a>
                    </li>
                  </ul>
              </div>
              </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>

    <div class="modal fade createNewModal" id="MyModal" tabindex="-1"  aria-hidden="true" >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content p-15 p-md-40">
          <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Détails - {{ (element?.reference) ? element.reference : "" }}</h5>
          </div>
          <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <div class="table-responsive">
          
            <table class="table text-nowrap align-middle mb-0">
              <tbody v-if="element">
                <tr>
                  <th> DATE </th>
                  <td> {{  (element.dateAppro) ? formatDate(element.dateAppro) : "" }} </td>
                  <th> MONTANT </th>
                  <td> {{ (element.montant) ? formatMontant(element.montant) : "" }} </td>
                </tr>
              </tbody>
            </table>

            <div v-if="element">
              <div v-for="(mag, index) in element.approMags" :key="index">
                <div class="bg-primary text-white p-10 mt-10">
                  <h5 class="modal-title fw-bold text-white">Magasin - {{ (mag.magasin.libelle) }}</h5>
                </div>

                <table class="table text-nowrap align-middle mb-0" style="width: 100%">
                  <tbody>
                    <tr>
                      <th> # </th>
                      <th> PRODUIT </th>
                      <th> QTE </th>
                      <th> PRIX ACHAT </th>
                    </tr>
                    <tr v-for="(prod, indexx) in mag.approMagProdConds" :key="indexx">
                      <td> {{ prod.id }} </td>
                      <td> {{ prod.produitConditionnement?.nomComplet }} </td>
                      <td> {{ prod.qteAppro }} </td>
                      <td> {{ prod.prixAchat }} </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
                
        </div>
          </div>
          <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
      </div>
    </div>

  </template>
  
<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { paginationFields } from '../Utilities/paginationFields';
import { error, suppression, format_date } from '../../utils/utils';
import ApiService from "../../services/ApiService";
import  { Vente }  from '../../models/Vente';
import { Approvisionnement } from '@/models/Approvisionnement';
import PaginationComponent from '@/components/Utilities/Pagination.vue';

  export default defineComponent({
    name: "ListeApprovisionnement",
    components: {
      PaginationComponent
    },
    setup: () => {

      const elements = ref<Array<Approvisionnement>>([])
      const selectedItem = ref(0);
      const element = ref<Approvisionnement>();

      // BEGIN PAGINATE
      const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            getAll(page_, limit_);
          } catch (error) {
            //
            
          }
        };
        function rechercher(){
          getAll(page.value, limit.value, searchTerm.value );
        }
      // END PAGINATE

      const recharger = () => {
        getAll();
      };

      onMounted(() => {
        getAll();
      })

      function getAll(page = 1, limi = 10, searchTerm = '') {
        return ApiService.get(`approvisionnements?page=${page}&limit=${limi}&mot=${searchTerm}&`)
        .then(({ data }) => {
          elements.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          // console.log("yes",data.data.data);
        })
        .catch(({ response }) => {
          error(response.data)
        });
      } 

      function detail(id) {
        return ApiService.get(`approvisionnement/${id}`)
        .then(({ data }) => {
          console.log('reglements', data.data);
          element.value = data.data;
        })
        .catch(({ response }) => {
          error(response.data)
        });
      }

      function formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      }

      function formatMontant(montant) {
        return montant.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }

      return { 
        getAll,
        suppression,
        elements,
        recharger,
        selectedItem,
        format_date,
        element,
        detail,
        formatDate,
        formatMontant,

        page,
        totalPages,
        totalElements,
        limit,
        searchTerm,
        handlePaginate,
        rechercher
      };
    }

  });
  
</script>